import React from 'react'
import moment from 'moment-timezone'
import AddToCalendarHOC from 'react-add-to-calendar-hoc'
import parse from 'html-react-parser'
import { Fade } from 'react-reveal'
import Select from 'react-select'

import Link from '../utils/link'
import useOfficesQuery from '../hooks/use-offices-query'
import useForSaleQuery from '../hooks/use-for-sale-query'
import useForLeaseQuery from '../hooks/use-lease-query'

const Upcoming = ({title, type}) => {

  let properties = useForSaleQuery()
  let rentals = useForLeaseQuery()
  if (type === 'inspections_rental') {
    properties = rentals
  }
  const allWpOffice = useOfficesQuery()
  const [state, setState] = React.useState({
    suburb: null,
    office: null,
    auctionDate: null,
    inspectionDate: null,
    suburbs: [],
  })

  if (type === 'inspections' || type === 'inspections_rental') {
    // Sort properties by inspections
    properties = properties.filter(el => !!el.propertyInspections[0]?.startDate)
    properties.sort((a, b) => {
      a.propertyInspections.sort((c, d) => {
        if (moment(c.startDate).isBefore(moment(d.startDate))) {
          return -1
        } else {
          return 1
        }
      })
      b.propertyInspections.sort((c, d) => {
        if (moment(c.startDate).isBefore(moment(d.startDate))) {
          return -1
        } else {
          return 1
        }
      })

      const inspectionsItemsA = a.propertyInspections.filter((ins) => {
        if (moment(ins.startDate, "YYYY-MM-DD").tz("Australia/Sydney").add(1, 'days').isBefore(new Date())) return false
        return true
      })

      const inspectionsItemsB = b.propertyInspections.filter((ins) => {
        if (moment(ins.startDate, "YYYY-MM-DD").tz("Australia/Sydney").add(1, 'days').isBefore(new Date())) return false
        return true
      })
      if (moment(inspectionsItemsA[0]?.startDate).tz("Australia/Sydney").isBefore(moment(inspectionsItemsB[0]?.startDate).tz("Australia/Sydney"))) {
        return -1
      } else {
        return 1
      }
    })
  }

  if (type === 'auctions') {
    // Sort properties by auctions
    properties = properties.filter(el => el.propertyListing.auctionDate && !moment(el.propertyListing.auctionDate, "YYYY-MM-DD").tz("Australia/Sydney").add(1, 'days').isBefore(new Date()))
    properties.sort((a, b) => {
      if (moment(a.propertyListing.auctionDate).tz("Australia/Sydney").isBefore(moment(b.propertyListing.auctionDate).tz("Australia/Sydney"))) {
        return -1
      } else {
        return 1
      }
    })
  }

  const [results, setResults] = React.useState(properties)

  const handleSelectChange = (option, field) => {
    switch (field && field.action) {
      case 'select-option':
        state[field.name] = option
        break
      case 'clear':
        state[field.name] = null
        break
      default:
        state[option.currentTarget.name] = option.currentTarget.value
        break
    }
    setState(state)
    updateList()
  }

  const updateList = () => {
    let list = properties
    let filteredResults = {}
    let { suburb, office, auctionDate, inspectionDate } = state
    if (list) {
      filteredResults = list.filter((el, i) => {
        if (suburb?.value && el.propertyAddress.suburb !== suburb.value) return false
        if (office?.value && el.propertyListing.officeName !== office.value)return false
        if (auctionDate?.value && moment(el.propertyListing.auctionDate).tz("Australia/Sydney").format('ddd D MMM') !== auctionDate.value) return false
        if (inspectionDate?.value && el.propertyInspections.findIndex(el => moment(el.startDate).tz("Australia/Sydney").format('ddd D MMM') === inspectionDate.value) === -1) return false
        return true
      })
    }
    setResults(filteredResults)
  }

  let suburbs = []
  let staff = []
  let auctionDates = []
  let inspectionDates = []
  let uniqueAuctionDates = []
  let uniqueInspectionDates = []

  properties.forEach((el) => {
    if (suburbs.indexOf(el.propertyAddress.suburb) === -1) {
      suburbs.push(el.propertyAddress.suburb)
    }
    if (allWpOffice.length > 0) {
      allWpOffice.forEach((office) => {
        if(staff.findIndex((option)=> option.label === office.title) === -1)
          staff.push({ label: office.title, value: office.officeDetails.name })
      })
    }
    if (type === 'auctions') {
      let auctionItem = el.propertyListing.auctionDate ? `${moment(el.propertyListing.auctionDate).tz("Australia/Sydney").format('ddd D MMM')}` : null
      if (!auctionItem || moment(el.propertyListing.auctionDate).isBefore(new Date())) {
        return null
      } else {
        auctionDates.push(moment(el.propertyListing.auctionDate).tz("Australia/Sydney").format('YYYY-MM-DD'))
      }
    }
    if (type === 'inspections' || type === 'inspections_rental') {
      let inspectionsItems = []
      inspectionsItems = el.propertyInspections.filter((ins) => {
        if (moment(ins.startDate, "YYYY-MM-DD").tz("Australia/Sydney").add(1, 'days').isBefore(new Date())) return false
        return true
      })
      if (inspectionsItems?.length === 0) { 
        return null
      } else {
        inspectionsItems.map((ins) => (
          inspectionDates.push(moment(ins.startDate).tz("Australia/Sydney").format('YYYY-MM-DD'))
        ))
      }
    }
  })
  staff.sort((a, b) => {
    return a.label > b.label ? 1 : -1
  })

  suburbs.sort()

  auctionDates.sort((a, b) => {
    return new Date(a) - new Date(b)
  })

  inspectionDates.sort((a, b) => {
    return new Date(a) - new Date(b)
  })

  let uniqueAuctionItems = [...new Set(auctionDates)]
  uniqueAuctionItems.map((auction) => (
    uniqueAuctionDates.push({
      label: moment(auction).tz("Australia/Sydney").format('ddd D MMM'),
      value: moment(auction).tz("Australia/Sydney").format('ddd D MMM')
    })
  ))

  let uniqueInspectionItems = [...new Set(inspectionDates)]
  uniqueInspectionItems.map((ins) => (
    uniqueInspectionDates.push({
      label: moment(ins).tz("Australia/Sydney").format('ddd D MMM'),
      value: moment(ins).tz("Australia/Sydney").format('ddd D MMM')
    })
  ))

  let suburbOptions = []
  suburbs.length > 0 && suburbs.map((el) => (
    suburbOptions.push({
      value: el,
      label: el
    })
  ))
  let officeOptions = []
  staff.length > 0 && staff.map((el) => (
    officeOptions.push({
      label: el.label,
      value: el.value
    })
  ))

  const ATCDropdown = (args) => (
    <ul className="atc-dropdown">
      {args.children.map((link, i) => (
        <li key={i}>{link}</li>
      ))}
    </ul>
  )

  const ATCWrapper = (args) => (
    <a onClick={args.onClick} className="atc-item" href="/">
      <span dangerouslySetInnerHTML={{ __html: args.children }} />
    </a>
  );
  const AddToCalendarDropdown = AddToCalendarHOC(ATCWrapper, ATCDropdown);

  let duration = 1;

  return (
    <section className={`upcoming ${type === 'auctions' ? 'upcoming__auction' : ''}`}>
      <div className='upcoming__inner'>
        <div className='upcoming__heading'>
          <h1>{title}</h1>
        </div>
        <div className='upcoming__filter search'>
          <div className='form__row--select'>
            <Select
              options={suburbOptions}
              onChange={handleSelectChange}
              openMenuOnFocus={true}
              id="suburb"
              name="suburb"
              value={state.suburb}
              placeholder='Filter by suburb'
              className="react-select-container"
              classNamePrefix="react-select"
              isClearable={true}
            />
          </div>

          { staff?.length > 0 && 
            <div className='form__row--select'>
              <Select
                options={officeOptions}
                onChange={handleSelectChange}
                openMenuOnFocus={true}
                id="office"
                name="office"
                value={state.office}
                placeholder='Filter by Office'
                className="react-select-container"
                classNamePrefix="react-select"
                isClearable={true}
              />
            </div>
          }
          { (type === 'auctions') && uniqueAuctionDates?.length > 0 && 
            <div className='form__row--select'>
              <Select
                options={uniqueAuctionDates}
                onChange={handleSelectChange}
                openMenuOnFocus={true}
                id="date"
                name="auctionDate"
                value={state.auctionDate}
                placeholder='Filter by date'
                className="react-select-container"
                classNamePrefix="react-select"
                isClearable={true}
              />
            </div>
          }
          { (type === 'inspections' || type === 'inspections_rental') && uniqueInspectionDates?.length > 0 && 
            <div className='form__row--select'>
              <Select
                options={uniqueInspectionDates}
                onChange={handleSelectChange}
                openMenuOnFocus={true}
                id="date"
                name="inspectionDate"
                value={state.inspectionDate}
                placeholder='Filter by date'
                className="react-select-container"
                classNamePrefix="react-select"
                isClearable={true}
              />
            </div>
          }
        </div>
        <Fade bottom distance='40px'>
          <div className='upcoming__table'>
            { results?.length === 0 &&
            <div className='upcoming__no-results'>
              <p>{ "Sorry, we haven’t found any results that meet your search criteria." }</p>
            </div>
            }
            { results?.length > 0 && results.map((el, i) => {
              let title = `${el.propertyAddress.streetAddress}, ${el.propertyAddress.suburb}`
              let beds = el.propertyData.bedrooms ? el.propertyData.bedrooms : null
              let baths = el.propertyData.bathrooms ? el.propertyData.bathrooms : null
              let cars = el.propertyData.totalParking ? el.propertyData.totalParking : null
              let auction = ''
              if ( type === 'auctions' ) {
                auction = el.propertyListing.auctionDate ? `${moment(el.propertyListing.auctionDate).tz("Australia/Melbourne").format('ddd D MMM YY')}` : null
                if (!auction || moment(el.propertyListing.auctionDate).isBefore(new Date())) return null
              }
              let auctionEvent = {}
              if ( el.propertyAddress.hideAddress ) {
                title = el.propertyAddress.suburb
              }
              let postType = 'property'
              if (type === 'inspections_rental') postType = 'rental'

              let pathName = `/${postType}/${el.slug}/`
              if (el.propertyAddress?.hideAddress) {
                pathName = `/${postType}/${el.propertyAddress.suburb.toLowerCase().replace(/ /gi, '-')}-${el.databaseId}/`
              }
              let auctionButton = ''

              if ( type === 'auctions' ) {
                auctionEvent = {
                  description: 'Auction',
                  duration,
                  endDatetime: moment(el.propertyListing.auctionDate).tz("Australia/Melbourne").add(1, 'hours').format("YYYYMMDDTHHmmss"),
                  location: el.propertyAddress.hideAddress ? el.propertyAddress.suburb : el.title,
                  startDatetime: moment(el.propertyListing.auctionDate).tz("Australia/Melbourne").format("YYYYMMDDTHHmmss"),
                  title: `Auction: ${el.propertyAddress.hideAddress ? el.propertyAddress.suburb : el.title}`,
                }
                auctionButton = `<span class="btn btn-border-powder"><svg width="12" height="11" viewBox="0 0 12 11" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.44 0.459961V4.93996H0.959999V6.05996H5.44V10.54H6.56V6.05996H11.04V4.93996H6.56V0.459961H5.44Z" fill="#0D283E"/></svg> Calendar</span>`
              }

              let inspections = []
              if (type === 'inspections' || type === 'inspections_rental') {
                inspections = el.propertyInspections.filter((ins) => {
                  if (moment(ins.startDate, "YYYY-MM-DD").tz("Australia/Melbourne").add(1, 'days').isBefore(new Date())) return false
                  return true
                })
                if (inspections?.length === 0) return null
              }

              return (
                <div className='upcoming__item' key={i}>
                  <div className='upcoming__image'>
                    <Link to={ pathName }><img src={ el.propertyImages?.[0]?.small } alt={ el.title }/></Link>
                  </div>
                  <div className='upcoming__wrapper'>
                    <Link to={ pathName } className='upcoming__content'>
                      <div>
                        <h4><Link to={ pathName }>{ title }</Link></h4>
                        <ul className='upcoming__specs'>
                          { beds && <li>{ beds } Bed</li> }
                          { baths && <li>{ baths } Bath</li> }
                          { cars && <li>{ cars } Car</li> }
                        </ul>
                      </div>
                    </Link>
                    <div className='upcoming__date'>
                      { type === 'auctions' &&
                      <>
                        <ul className='inspections-list'>
                          <li>
                            { el.propertyListing.auctionVenue && <>{ parse(el.propertyListing.auctionVenue) }<br/></> }
                            { moment(el.propertyListing.auctionDate).format('ddd D MMM h:mmA') }
                            <AddToCalendarDropdown buttonText={ auctionButton } event={ auctionEvent }/>
                          </li>
                        </ul>
                      </>
                      }
                      { (type === 'inspections' || type === 'inspections_rental') && inspections?.length > 0 &&
                      <>
                        <ul className='inspections-list'>
                          { inspections.slice(0, 6).map((ins, i) => {
                            let inspection_date = ins.startDate
                            let inspection_time_start = ins.startDate
                            let inspection_time_end = ins.endDate
                            let inspectionEvent = {
                              description: `Open For Inspection @ ${ el.propertyAddress.hideAddress ? el.propertyAddress.addressSuburb : el.title }`,
                              duration,
                              endDatetime: moment(inspection_time_end).tz('Australia/Melbourne').add(1, 'hours').format('YYYYMMDDTHHmmss'),
                              location: el.propertyAddress.hideAddress ? el.propertyAddress.addressSuburb : el.title,
                              startDatetime: moment(inspection_time_start).tz('Australia/Melbourne').format('YYYYMMDDTHHmmss'),
                              title: `${ el.propertyAddress.hideAddress ? el.propertyAddress.addressSuburb : el.title } - Open For Inspection`,
                            }
                            let inspectionButton = `${ moment(inspection_date).tz('Australia/Melbourne').format('ddd D MMM Y') }<br>${ moment(inspection_time_start).tz('Australia/Melbourne').format('h:mm A') } - ${ moment(inspection_time_end).tz('Australia/Melbourne').format('h:mm A') }`
                            return (
                              <li key={ i }>
                                <AddToCalendarDropdown buttonText={ inspectionButton } event={ inspectionEvent }/>
                              </li>
                            )
                          }) }
                        </ul>
                      </>
                      }
                    </div>
                  </div>
                  {type === 'auctions' && <div className='upcoming__date upcoming__date--mobile'>
                    { type === 'auctions' &&
                    <>
                      <ul className='inspections-list'>
                        <li>
                          { el.propertyListing.auctionVenue && <>{ parse(el.propertyListing.auctionVenue) }<br/></> }
                          { moment(el.propertyListing.auctionDate).format('ddd D MMM h:mmA') }
                          <AddToCalendarDropdown buttonText={ auctionButton } event={ auctionEvent }/>
                        </li>
                      </ul>
                    </>
                    }
                    { (type === 'inspections' || type === 'inspections__rental') && inspections?.length > 0 &&
                    <>
                      <ul className='inspections-list'>
                        { inspections.slice(0, 6).map((ins, i) => {
                          let inspection_date = ins.startDate
                          let inspection_time_start = ins.startDate
                          let inspection_time_end = ins.endDate
                          let inspectionEvent = {
                            description: `Open For Inspection @ ${ el.propertyAddress.hideAddress ? el.propertyAddress.addressSuburb : el.title }`,
                            duration,
                            endDatetime: moment(inspection_time_end).tz('Australia/Melbourne').add(1, 'hours').format('YYYYMMDDTHHmmss'),
                            location: el.propertyAddress.hideAddress ? el.propertyAddress.addressSuburb : el.title,
                            startDatetime: moment(inspection_time_start).tz('Australia/Melbourne').format('YYYYMMDDTHHmmss'),
                            title: `${ el.propertyAddress.hideAddress ? el.propertyAddress.addressSuburb : el.title } - Open For Inspection`,
                          }
                          let inspectionButton = `${ moment(inspection_date).tz('Australia/Melbourne').format('ddd D MMM Y') }<br>${ moment(inspection_time_start).tz('Australia/Melbourne').format('h:mm A') } - ${ moment(inspection_time_end).tz('Australia/Melbourne').format('h:mm A') }`
                          return (
                            <li key={ i }>
                              <AddToCalendarDropdown buttonText={ inspectionButton } event={ inspectionEvent }/>
                            </li>
                          )
                        }) }
                      </ul>
                    </>
                    }
                  </div>}
                </div>
              )
            })}
          </div>
        </Fade>
      </div>
    </section>
  )
}

export default Upcoming
